import { render, staticRenderFns } from "./editMark.vue?vue&type=template&id=58204fc1&scoped=true&"
import script from "./editMark.vue?vue&type=script&lang=js&"
export * from "./editMark.vue?vue&type=script&lang=js&"
import style0 from "./editMark.vue?vue&type=style&index=0&id=58204fc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58204fc1",
  null
  
)

export default component.exports